/* @flow */

import React, { Component } from 'react'
import { connect } from 'react-redux'
import type { RouterHistory } from 'react-router-dom'

import type { Dispatch } from '../types'
import { Content, ContentHeader, WhiteBox } from '../template/Content'
import { getUserEntities, switchEntity } from '../template/actions'

type ReactReduxProps = {
  dispatch: Dispatch,
  history: RouterHistory,
}

type Props = ReactReduxProps

type State = {
  userEntities: Array<{ id: number, name: string, entity_type: string }>,
}

class AgencyDashboard extends Component<Props, State> {
  state = {
    userEntities: [],
  }

  componentDidMount() {
    this.props.dispatch(getUserEntities()).then(response => {
      this.setState({ userEntities: response.payload })
    })
  }

  switchEntity = entityId => {
    this.props.dispatch(switchEntity(entityId, this.props.history))
  }

  render() {
    const { userEntities } = this.state

    const brands = userEntities.filter(entity => entity.entity_type === 'brand')

    const breadcrumbs = [{ label: 'Agency Dashboard' }]

    return (
      <div>
        <ContentHeader breadcrumbs={breadcrumbs} actions={[]} />
        <Content>
          <WhiteBox>
            <p>Agency ID: {this.props.entity.id}</p>

            {brands.length > 0 && (
              <>
                You have access to following brands, click one to switch to it:
                <ul>
                  {brands.map(entity => (
                    <li key={entity.id}>
                      <a
                        href="javascript:;"
                        onClick={() => this.switchEntity(entity.id)}
                      >
                        {entity.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </>
            )}
            {brands.length === 0 && (
              <>At the moment you don't have access to any brands.</>
            )}
          </WhiteBox>
        </Content>
      </div>
    )
  }
}

export default connect(state => ({
  entity: state.session.entity,
}))(AgencyDashboard)
